
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ads/1",
      function () {
        return require("private-next-pages/ads/1.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ads/1"])
      });
    }
  